import React, { useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { signupAdmin } from "../services/userAdminApi";

const CreateAdminModal = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const handleOk = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await signupAdmin(values);
      message.success("Un Administrateur créé avec succès !");
      form.resetFields();
      onClose();
    } catch (err) {
      console.error("Erreur création admin :", err.message);
      message.error("❌ Une erreur est survenue lors de la création.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
  title="Créer un administrateur"
  open={visible}
  onCancel={onClose}
    footer={[
      <Button key="cancel" onClick={onClose}>Annuler</Button>,
      <Button key="submit"type="primary"loading={loading}onClick={handleOk}>Créer</Button>
      ]}>
      <Form form={form} layout="vertical">
        <Form.Item
          label="Nom"
          name="lastName"
          rules={[{ required: true, message: "Veuillez entrer le nom" }]}
        >
          <Input placeholder="Nom" />
        </Form.Item>
        <Form.Item
          label="Prénom"
          name="firstName"
          rules={[{ required: true, message: "Veuillez entrer le prénom" }]}
        >
          <Input placeholder="Prénom" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Veuillez entrer l'email" },
            { type: "email", message: "Email invalide" },
          ]}
        >
          <Input placeholder="exemple@mail.com" />
        </Form.Item>

        <Form.Item
          label="Téléphone"
          name="phoneNumber"
          rules={[{ required: true, message: "Veuillez entrer le téléphone" }]}
        >
          <Input placeholder="+xx xxx xx xx" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateAdminModal;
